import { render, staticRenderFns } from "./AbCmykInput.vue?vue&type=template&id=0babeb79&scoped=true"
import script from "./AbCmykInput.vue?vue&type=script&lang=js"
export * from "./AbCmykInput.vue?vue&type=script&lang=js"
import style0 from "./AbCmykInput.vue?vue&type=style&index=0&id=0babeb79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0babeb79",
  null
  
)

export default component.exports